import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { CniScadaSummaryTable } from "@/features/cni-scada/components/CniScadaSummaryTable"

export const Route = createFileRoute("/_authed/cni/scada")({
  component: CniScadaPage,
})

function CniScadaPage() {
  const { t } = useTranslation("cni-scada")
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4 shrink-0">
        <h1 className="text-lg font-semibold tracking-tight">{t("title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("subtitle")}</p>
      </div>
      <CniScadaSummaryTable />
    </div>
  )
}
